/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-11-04 15:23:08
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-16 19:41:49
 */
import request from '@/utils/request';
import { AjaxMethod } from '@/utils/dataMap';
// 店铺列表
export const cooperativeShopList = data => {
	return request({
		url: '/api/cooperative-shop/list',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 协作列表
export const cooperativeList = data => {
	return request({
		url: '/api/cooperative-shop/cooperative-list',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 获取协作链接
export const cooperativeShopGetLink = data => {
	return request({
		url: '/api/cooperative-shop/get-link',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 修改备注
export const setShopInfoRemark = data => {
	return request({
		url: '/api/cooperative-shop/set-shop-info-remark',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 取消店铺绑定
export const cancelBind = data => {
	return request({
		url: '/api/cooperative-shop/cancel-bind',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 获取规则详情
export const institutionGetRule = data => {
	return request({
		url: '/api/team-institution/get-rule',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 设置规则详情
export const institutionSaveRule = data => {
	return request({
		url: '/api/team-institution/save-rule',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 关闭规则
export const institutionCloseRule = data => {
	return request({
		url: '/api/team-institution/close-rule',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 添加店铺
export const institutionAddShop = data => {
	return request({
		url: '/api/team-institution/add-shop',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 添加店铺
export const institutionGetShopList = data => {
	return request({
		url: '/api/team-institution/get-shop-list',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 移除店铺规则
export const institutionDelRule = data => {
	return request({
		url: '/api/team-institution/del-rule',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 移除店铺规则
export const shopCooperationStatus = data => {
	return request({
		url: '/api/cooperative-shop/cooperation-status',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 移除店铺规则
export const getShopNames = data => {
	return request({
		url: '/api/cooperative-shop/get-shop-names',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 我的机构列表
export const shopAuthorityList = data => {
	return request({
		url: '/api/cooperative-shop/authority',
		data,
		method: AjaxMethod.post,
		notOrigin: false,
	});
};

// 样品自动协作用户列表
export const userSmpleList = data => {
	return request({
		url: '/api/cooperative-shop/user-sample-list',
		data,
		method: AjaxMethod.post,
		notOrigin: false,
	});
};

// 修改店铺用户协作状态
export const editUserSampleStatus = data => {
	return request({
		url: '/api/cooperative-shop/user-sample-status',
		data,
		method: AjaxMethod.post,
		notOrigin: false,
	});
};

// 商团协作邀约进度
export const getBindCount = data => {
	return request({
		url: '/api/cooperative-shop/get-bind-count',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 获取修改对接人列表
export const getCooperativeShop = params => {
	return request({
		url: '/api/cooperative-shop/shop-list',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

// 设置店铺新对接人
export const setNewShopUser = params => {
	return request({
		url: '/api/cooperative-shop/set-shop-claim-user',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};
